import React from "react";
import clsx from "clsx";

import Container from "@components/Atomic/Container/Container";
import { ImageProps, withImage } from "./withImage";
import { NestedWrapper } from "../NestedWrapper";

import { SanityImage, SanityLink } from "@bared/ui";

const Parent = ({ children }: Partial<ImageProps>) => {
  return <div className="w-full">{children}</div>;
};

const Child = ({
  image,
  mobileImage,
  imageLink,
  mobileImageLink,
}: Partial<ImageProps>) => {
  return (
    <>
      {!!image && !!image.asset && (
        <div
          className={clsx(
            !!mobileImage?.asset ? "hidden md:block" : "block",
            "mx-auto h-full",
          )}
        >
          {imageLink ? (
            <SanityLink
              data={imageLink}
              target={imageLink.external ? "_blank" : "_self"}
              rel="noopener noreferrer"
            >
              <SanityImage
                className="mx-auto h-full w-full"
                data={image.asset}
                altText={image?.alt ?? ""}
                maxWidth={1000}
                loading="eager"
              />
            </SanityLink>
          ) : (
            <SanityImage
              className="mx-auto h-full w-full"
              data={image.asset}
              altText={image?.alt ?? ""}
              maxWidth={1000}
              loading="eager"
            />
          )}
        </div>
      )}

      {!!mobileImage && !!mobileImage.asset && (
        <div className="h-full md:hidden">
          {mobileImageLink ? (
            <SanityLink
              data={mobileImageLink}
              target={mobileImageLink.external ? "_blank" : "_self"}
              rel="noopener noreferrer"
            >
              <SanityImage
                className="mx-auto h-full w-full"
                data={mobileImage.asset}
                altText={mobileImage?.alt ?? ""}
                maxWidth={1000}
                loading="eager"
              />
            </SanityLink>
          ) : (
            <SanityImage
              className="mx-auto h-full w-full"
              data={mobileImage.asset}
              altText={mobileImage?.alt ?? ""}
              maxWidth={1000}
              loading="eager"
            />
          )}
        </div>
      )}
    </>
  );
};

const Image = withImage(({ as, background, styles, ...rest }) => {
  return (
    <Container
      as={as}
      styles={styles}
      legacy={!styles?.length}
      background={background}
      data-component-type="section-image"
    >
      <NestedWrapper {...rest} renderChild={Child} renderParent={Parent} />
    </Container>
  );
});

export default Image;
